import { z } from 'zod';

import { emailSchema, isoDateTimeSchema, ulidSchema } from './primitives';

export const membershipRoleSchema = z.enum(['OWNER', 'ADMIN', 'STAFF']);
export type MembershipRole = z.infer<typeof membershipRoleSchema>;

export const membershipEntitySchema = z.object({
  restaurantId: ulidSchema,
  /** Cognito `sub` (UUID or ULID depending on pool configuration). */
  userId: z.string().min(1).max(128),
  role: membershipRoleSchema,
  permissions: z.array(z.string()).default([]),
  inviteEmail: emailSchema.optional(),
  /** Cognito `sub` of the inviter when recorded. */
  invitedByUserId: z.string().min(1).max(128).optional(),
  invitedAt: isoDateTimeSchema,
  acceptedAt: isoDateTimeSchema.optional(),
});
export type MembershipEntity = z.infer<typeof membershipEntitySchema>;

export const membershipOwnerSchema = z.object({
  userId: z.string().min(1).max(128),
  role: membershipRoleSchema,
  permissions: z.array(z.string()),
  inviteEmail: emailSchema.optional(),
  invitedAt: isoDateTimeSchema,
  acceptedAt: isoDateTimeSchema.optional(),
});
export type MembershipOwner = z.infer<typeof membershipOwnerSchema>;

export const membershipAdminSchema = membershipOwnerSchema.extend({
  restaurantId: ulidSchema,
  invitedByUserId: z.string().min(1).max(128).optional(),
});
export type MembershipAdmin = z.infer<typeof membershipAdminSchema>;
